classnames = require('classnames')
component = React.createElement
dom = React.DOM
{ PropTypes } = React
{ Search, Table, sortColumn } = require('reactabular')

require('./style')

TableWrapper = React.createClass({
  propTypes: {
    actionString: PropTypes.string
    isActionDisabled: PropTypes.bool
    onAction: PropTypes.func
    headerString: PropTypes.string
    columns: PropTypes.array.isRequired
    data: PropTypes.array.isRequired
    searchQuery: PropTypes.string
  }

  getHeader: ->
    {
      onClick: (column) =>
        sortColumn(@state.columns, column, @setState.bind(@))
    }

  getInitialState: ->
    {
      searchQuery: @props.searchQuery or ''
      columns: @props.columns
      header: @getHeader()
    }

  render: ->
    data = Search.search(@props.data, @state.columns, 'all', @state.searchQuery)
    data = sortColumn.sort(data, @state.sortingColumn)

    dom.div { className: 'Table' },
      dom.div { className: 'table-header' },
        if @props.headerString
          dom.h2 {}, @props.headerString
        else
          dom.div {}

        dom.div { className: 'flex' },
          dom.input {
            className: 'search'
            placeholder: 'Search…'
            onChange: @onSearch
          }
          if @props.actionString and @props.onAction
            dom.button {
              disabled: @props.isActionDisabled
              onClick: @props.onAction
            }, @props.actionString
          else
            dom.div {}

      component Table, {
        header: @state.header
        columns: @state.columns
        data: data
        rowKey: 'id'
      }

      @props.children

  onSearch: (event) ->
    @setState({ searchQuery: event.target.value })

})

module.exports = TableWrapper



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Table/index.coffee